module.exports = __webpack_public_path__ + "static/media/CourseFailed.b7f83e34.svg";